import { render, staticRenderFns } from "./tools.vue?vue&type=template&id=b012c4c6&scoped=true&"
import script from "./tools.vue?vue&type=script&lang=js&"
export * from "./tools.vue?vue&type=script&lang=js&"
import style0 from "./tools.vue?vue&type=style&index=0&id=b012c4c6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b012c4c6",
  null
  
)

export default component.exports